export const ISSUES_DASHBOARD_PATH = '/issues/dashboard'
export const ISSUES_DASHBOARD_SEARCH_PATH = '/issues/dashboard/search'
